import { TaxSectionProps } from ".";
import { InputButton } from "../../components/Forms/InputButton";
import { Text } from "../../components/Forms/InputButton/styles";
import { DebitCardConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { Rewind } from "../../styles/icons/Rewind";
import { clearMask, formatCurrency, formatCurrencyToApiNoThrow } from "../../utils";
import { formatPaymentRangeFromApi, formatPaymentRangeToApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Divider, Header, Section } from "./styles";

interface DebitSectionProps extends TaxSectionProps {
  debitConfigData: DebitCardConfig;
  defaultDebitConfigData: DebitCardConfig;
}

export function DebitSection({
  editionMode = false,
  debitConfigData,
  asModalView,
  defaultDebitConfigData,
  register,
  errors,
  watch,
  setValue,
  colorFinder
}: DebitSectionProps) {
  const delayForRedeem = formatTextView("debitDelayForRedeem", "delayForRedeem", formatPaymentRangeFromApi);
  const value = formatBankSlipValueView("debitValue", "rate", watch);

  function handleSetDefaultValue(name: string, defaultValue: string, func: any) {
    const convertionFunction = {
      "range": formatPaymentRangeFromApi,
      "currency": (value) => formatCurrency({ value })
    }
    setValue(name, convertionFunction[func](defaultDebitConfigData[defaultValue]))
  }
  function formatTextView(auxName: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean, formaterAsRateType?: boolean): JSX.Element {
    const defaultValueFormatted = formaterAsCurrency ? formater({ value: defaultDebitConfigData[innerValue] }) : formater(defaultDebitConfigData[innerValue]);
    if(!debitConfigData[innerValue]) return
    const pastValue = formaterAsCurrency ? formater({ value: debitConfigData[innerValue] }) : formater(debitConfigData[innerValue]);
    const laterValue = formaterAsRateType ? formater(defaultDebitConfigData[innerValue]) : watch(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }

  function formatBankSlipValueView(auxName: string, defaultValue: string, getValue: any) {
    const defaultRateType = defaultDebitConfigData["rateType"];
    const defaultValueFormatted = defaultRateType === "percent" ? formatPercentageToNumber(defaultDebitConfigData[defaultValue]) : formatCurrency({ value: defaultDebitConfigData[defaultValue] });
    const pastValue: any = defaultRateType === "percent" ? formatPercentageToNumber(defaultDebitConfigData[defaultValue]) : formatCurrency({value: defaultDebitConfigData[defaultValue]});
    const laterValue: any = getValue(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  return (
    <Section flexDir="column">
      <Section gap=".4rem" margin={asModalView ? "1rem 0 0" : ""}>
      <CreditCardIcon />
        <Header>Cartão Débito</Header>
      </Section>
      {!asModalView && (
        <Section>
          <InputButton
            disabled={!editionMode}
            label="Tempo de repasse"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            name="debitDelayForRedeem"
            mask="paymentRange"
            register={{ ...register("debitDelayForRedeem") }}
            defaultValue={formatPaymentRangeFromApi(watch("debitDelayForRedeem"))}
            buttonFunction={() => handleSetDefaultValue("debitDelayForRedeem", "delayForRedeem", "range")}
            color={() => colorFinder(formatPaymentRangeToApi(watch("debitDelayForRedeem")), defaultDebitConfigData?.delayForRedeem)}
            buttonDisabled={formatPaymentRangeToApi(watch("debitDelayForRedeem")) === defaultDebitConfigData?.delayForRedeem}
            icon={<Rewind color={formatPaymentRangeToApi(watch("debitDelayForRedeem")) === defaultDebitConfigData?.delayForRedeem ? "#00000040" : "black"} />}
            errors={errors?.debitDelayForRedeem}
          />
          <InputButton
            disabled={!editionMode}
            label="Taxa"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            mask={watch("rateType") === "percent" ? "percentageRacional" : "currencyE"}
            name="debitValue"
            register={{ ...register("debitValue") }}
            defaultValue={watch("rateType") === "percent" ? formatPercentageToNumber(watch("debitValue")) : formatCurrency({value: watch("debitValue")})}
            buttonFunction={() => watch("rateType") === "percent" ? setValue("debitValue", formatPercentageToNumber(0.8)) : setValue("debitValue", formatCurrency({value: 2.85}))}
            color={() => colorFinder(formatCurrencyToApiNoThrow(watch("debitValue")), defaultDebitConfigData?.rate)}
            buttonDisabled={formatCurrencyToApiNoThrow(watch("debitValue")) === defaultDebitConfigData?.rate}
            icon={<Rewind color={formatCurrencyToApiNoThrow(watch("debitValue")) === defaultDebitConfigData?.rate ? "#00000040" : "black"} />}
            errors={errors?.debitValue}
          />
        </Section>
      )}
      {asModalView && (
        <Section flexDir="column">
          <Section> 
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tempo de repasse
              </Text>
              {delayForRedeem}
            </Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Taxa
              </Text>
              {value}
            </Section>
          </Section>
        </Section>
      )}
      <Divider />
    </Section>
  )
}